import React from "react";

import SubscriptionInfoSlice from "../../components/slices/subscriptionInfo/SubscriptionInfoSlice";

const SubscriptionInfo = ({ slice }) => {
  return <SubscriptionInfoSlice slice={slice} />;
};

export default SubscriptionInfo;
